import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/knowlarity`;

export interface KnowlarityCredential {
  api_key: string;
  virtual_number: string;
  is_active: boolean;
  updated_at: string | null;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

// ✅ POST: Verify and store Knowlarity credentials
export const verifyKnowlarityApp = async (
  api_key: string,
  auth_key: string,
  virtual_number: string
): Promise<any> => {
  try {
    const formData = new URLSearchParams();
    formData.append("api_key", api_key);
    formData.append("auth_key", auth_key);
    formData.append("virtual_number", virtual_number);

    const response = await axios.post(
      `${BASE_URL}/app/integration`,
      formData,
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    toast.success("Knowlarity app verified successfully!");
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to verify Knowlarity credentials");
    throw error;
  }
};

// ✅ GET: Fetch stored Knowlarity credentials
export const getKnowlarityCredentials = async (): Promise<KnowlarityCredential> => {
  try {
    const response = await axios.get(`${BASE_URL}/credentials/get`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch Knowlarity credentials");
    throw error;
  }
};
